module.exports = __webpack_public_path__ + "img/colegio_tecnico_javier.f09db0d1.png";